import React from 'react'
import { Box, ButtonBase, Checkbox, CircularProgress } from '@mui/material'
import variables from '../../variables.module.scss'
import { CheckboxIcon } from '../modals/ServiceMapModal/components/CheckboxIcon'
import { TrafficWebSocketStreamingOption } from './WebsocketOptionsDropdown'
import { HalfEyeIcon } from '../UI/Icons/HalfEyeIcon'
import { FullEyeIcon } from '../UI/Icons/FullEyeIcon'

interface WebsocketOptionProps {
  title: string
  description: string
  option: TrafficWebSocketStreamingOption
  chosen: boolean
  setChosen: (val: boolean) => void
  onHold: boolean
}

export const WebsocketOption: React.FC<WebsocketOptionProps> = ({
  title,
  description,
  option,
  chosen,
  setChosen,
  onHold,
}) => {
  return (
    <ButtonBase
      onClick={() => setChosen(true)}
      sx={{
        width: '100%',
        display: 'block',
        textTransform: 'unset !important',
        letterSpacing: 'unset !important',
        opacity: !chosen && onHold ? 0.5 : 1,
        pointerEvents: onHold ? 'none' : 'all'
      }}
    >
      <Box
        boxSizing='border-box'
        padding='12px 16px'
        display='flex'
        alignItems='flex-start'
        borderRadius='6px'
        bgcolor={chosen ? variables.lighterGrayBlueColor : variables.mainBackgroundColor}
        border={`1px solid ${chosen ? variables.lighterBlueColor : variables.lightGrayBlueColor}`}
        sx={{
          transition: '0.2s background'
        }}
      >
        <Box
          boxSizing='border-box'
          mr='15px'
          padding='10px'
          display='flex'
          alignItems='center'
          alignSelf='center'
          borderRadius='6px'
          bgcolor={chosen ? variables.lighterBlueColor : variables.lightGrayBlueColor}
        >
          {option === TrafficWebSocketStreamingOption.FlowsOnly &&
            <HalfEyeIcon
              size={28}
              fill={chosen ? variables.blueColor : variables.lightGrayColor}
              stroke={chosen ? variables.blueColor : variables.lightGrayColor}
            />}
          {option === TrafficWebSocketStreamingOption.Detailed &&
            <FullEyeIcon
              size={28}
              fill={chosen ? variables.blueColor : variables.lightGrayColor}
            />}
        </Box>
        <Box
          boxSizing='border-box'
          display='flex'
          alignItems='flex-start'
          alignSelf='center'
          flexDirection='column'
          gap='12px'
          flex='1'
          borderRadius='6px'
        >
          <Box
            boxSizing='border-box'
            display='flex'
            alignItems='center'
            gap='10px'
            borderRadius='6px'
          >
            <h1
              style={{
                margin: 0,
                flex: 1,
                fontFamily: 'Roboto, sans-serif',
                fontWeight: 500,
                fontSize: '15px',
                color: chosen ? variables.fontColor : variables.fontColorAlt
              }}
            >
              {title}
            </h1>
          </Box>
          <p
            style={{
              margin: 0,
              fontFamily: 'Source Sans Pro, sans-serif',
              fontWeight: 500,
              fontSize: '14px',
              letterSpacing: '0.005em',
              color: variables.darkSlateColor
            }}
          >
            {description}
          </p>
        </Box>
        {chosen && onHold ? (
          <CircularProgress size={18} sx={{
            marginTop: '5px',
            marginLeft: '3px',
            marginRight: '5px',
            color: variables.blueColor
          }} />
        ) : (
          <Checkbox
            checked={chosen}
            icon={<CheckboxIcon />}
            checkedIcon={<CheckboxIcon checked />}
            onChange={() => setChosen(true)}
            sx={{
              height: '26px',
              width: '26px',
            }}
          />
        )}

      </Box>
    </ButtonBase>
  )
}
